import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { MapPin, Phone, Clock, EnvelopeSimple, User, ArrowRight, MagnifyingGlass } from "@phosphor-icons/react";

export default function PublicBranches() {
  const [branches, setBranches] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => {
    api.get("/public/branches").then((r) => setBranches(r.data || [])).catch(() => {});
  }, []);

  const filtered = q.trim()
    ? branches.filter((b) => `${b.name} ${b.area} ${b.city} ${b.code}`.toLowerCase().includes(q.toLowerCase()))
    : branches;

  return (
    <div className="max-w-7xl mx-auto px-4 py-14" data-testid="public-branches">
      <div className="text-center mb-12 max-w-2xl mx-auto">
        <div className="text-[10px] uppercase tracking-[0.25em] font-semibold text-[#1e3a8a] mb-1.5">Branch Locator</div>
        <h1 className="text-3xl sm:text-4xl font-bold text-slate-900" style={{ fontFamily: "var(--font-heading)" }}>Find your nearest DigitalSetu.</h1>
        <p className="text-slate-600 mt-2">Walk in and get help from our friendly staff. Or call ahead and we'll keep your documents ready.</p>
      </div>

      <div className="max-w-md mx-auto mb-8">
        <div className="flex items-center gap-2 bg-white border border-slate-200 rounded-full pl-4 pr-2 py-1.5">
          <MagnifyingGlass size={16} className="text-slate-400" />
          <input value={q} onChange={(e) => setQ(e.target.value)} className="flex-1 py-1.5 outline-none bg-transparent text-sm" placeholder="Search by city, area or branch name…" data-testid="branch-search" />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {filtered.map((b) => (
          <div key={b.id} data-testid={`branch-${b.id}`} className={`bg-white border rounded-2xl p-6 hover:shadow-md transition-all ${b.is_head_office ? "border-orange-400 ring-2 ring-orange-200" : "border-slate-200 hover:border-[#1e3a8a]"}`}>
            <div className="flex items-start justify-between mb-3">
              <div>
                <div className="flex items-center gap-2 mb-1">
                  <div className="text-[10px] uppercase tracking-widest text-slate-500 font-semibold">{b.code || "Branch"}</div>
                  {b.is_head_office && (
                    <span className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full bg-orange-100 text-orange-800 text-[9px] uppercase tracking-widest font-bold" data-testid="badge-head-office">
                      🏢 Head Office
                    </span>
                  )}
                </div>
                <div className="text-lg font-bold text-slate-900" style={{ fontFamily: "var(--font-heading)" }}>{b.name}</div>
              </div>
              <div className={`w-9 h-9 rounded-full flex items-center justify-center ${b.is_head_office ? "bg-orange-100" : "bg-blue-50"}`}>
                <MapPin size={16} className={b.is_head_office ? "text-orange-600" : "text-[#1e3a8a]"} weight="fill" />
              </div>
            </div>
            <div className="space-y-1.5 text-sm text-slate-600">
              {(b.area || b.city) && <div className="flex items-start gap-2"><MapPin size={14} className="mt-0.5 shrink-0 text-slate-400" /> <span>{b.area}{b.city ? `, ${b.city}` : ""}</span></div>}
              {b.phone && <div className="flex items-center gap-2"><Phone size={14} className="text-slate-400" /> <a href={`tel:${b.phone}`} className="hover:text-[#1e3a8a]">{b.phone}</a></div>}
              {b.email && <div className="flex items-center gap-2"><EnvelopeSimple size={14} className="text-slate-400" /> <a href={`mailto:${b.email}`} className="hover:text-[#1e3a8a] truncate">{b.email}</a></div>}
              <div className="flex items-center gap-2"><Clock size={14} className="text-slate-400" /> <span>{b.hours}</span></div>
              {b.manager && <div className="flex items-center gap-2"><User size={14} className="text-slate-400" /> <span>Manager: {b.manager}</span></div>}
            </div>
            <div className="mt-4 flex gap-2 flex-wrap">
              <Link to="/apply" className="inline-flex items-center gap-1 px-4 h-9 rounded-full bg-[#ea580c] text-white text-xs font-semibold hover:bg-orange-700">Apply Now <ArrowRight size={11} /></Link>
              {b.phone && <a href={`tel:${b.phone}`} className="inline-flex items-center gap-1 px-4 h-9 rounded-full border border-slate-200 text-slate-700 text-xs font-semibold hover:border-[#1e3a8a]"><Phone size={11} /> Call</a>}
            </div>
          </div>
        ))}
        {filtered.length === 0 && (
          <div className="col-span-full text-center py-16 text-slate-400 text-sm">No branches match "{q}"</div>
        )}
      </div>
    </div>
  );
}
